"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusIndicator = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _Indicator = require("./Indicator.js");
var _excluded = ["semanticColor", "color"];
/**
 * StatusIndicator tells users about the current status of something using a colored dot and text label.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-statusindicator--docs) |
 * [Encore site](https://encore.spotify.net/web/components/status-indicator) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/StatusIndicator) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-10375&t=608qKxXhWG8gyhvB-1)
 */
var StatusIndicator = exports.StatusIndicator = function StatusIndicator(_ref) {
  var _ref$semanticColor = _ref.semanticColor,
    semanticColor = _ref$semanticColor === void 0 ? 'essentialBrightAccent' : _ref$semanticColor,
    color = _ref.color,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Indicator.Indicator, Object.assign({
    $statusColor: semanticColor
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.StatusIndicator
  }));
};